
const ScrollWrapper = ({ children }) => {
  return (
    <div className="h-full w-full overflow-hidden flex">
        <div className="h-full w-full overflow-y-auto flex">
            {children}
        </div>
    </div>
  );
}
export default ScrollWrapper;